<template>
    <ModalComponent
        name="aviso-tpv"
        title="Alerta sobre el TPV"
        @close="() => close()"
    >
        <h3 class="text-danger">{{ texto_aviso }}</h3>
        <div class="text-right">
            <Button type="button" name="button" @click.prevent="continuar()" class="text-right">Continuar compra</Button>
        </div>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['texto_aviso'],
    methods: {
        continuar() {
            this.$emit('close');
        }
    },
    components: {
        ModalComponent
    }
}
</script>